// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AaoY","question":"styles_question__TwDo4","inputVisibleButton":"styles_inputVisibleButton__2MoGR","note":"styles_note__1-Nck"};